/**
 * @fileoverview Filtro por etiquetas: busca as tags da empresa e renderiza o
 * FilterPopover (layout compartilhado com o filtro por Setores). Inclui a opção
 * "Sem etiquetas" controlada via prop `withoutTags`.
 */

import React, { useEffect, useState } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { FilterPopover } from "../FilterPopover";

export function TagsFilter({
  selectedTagIds = [],
  withoutTags = false,
  onChange,
  placeholder,
  title,
  searchPlaceholder,
  noTagsLabel,
  noTagsFoundLabel,
  singleSelectedLabel,
  multipleSelectedLabel,
  showingAllLabel,
  selectAllLabel,
  clearLabel,
  loadingLabel,
  fullWidth = false,
  disabled = false,
  className,
  placement,
}) {
  const [allTags, setAllTags] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchTags = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/tags/list");
        if (!cancelled) setAllTags(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!cancelled) toastError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchTags();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleToggleTag = (tagId) => {
    const next = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter((id) => id !== tagId)
      : [...selectedTagIds, tagId];
    onChange({ tagIds: next, withoutTags });
  };

  return (
    <FilterPopover
      options={allTags}
      selectedIds={selectedTagIds}
      onToggleOption={handleToggleTag}
      onSelectAll={(ids) => onChange({ tagIds: ids, withoutTags })}
      onClear={() => onChange({ tagIds: [], withoutTags: false })}
      noneOption={{
        label: noTagsLabel,
        selected: withoutTags,
        onToggle: () => onChange({ tagIds: selectedTagIds, withoutTags: !withoutTags }),
      }}
      loading={loading}
      placeholder={placeholder}
      title={title}
      searchPlaceholder={searchPlaceholder}
      emptyLabel={noTagsFoundLabel}
      singleSelectedLabel={singleSelectedLabel}
      multipleSelectedLabel={multipleSelectedLabel}
      showingAllLabel={showingAllLabel}
      selectAllLabel={selectAllLabel}
      clearLabel={clearLabel}
      loadingLabel={loadingLabel}
      fullWidth={fullWidth}
      disabled={disabled}
      className={className}
      placement={placement}
    />
  );
}
